import React from 'react';
export function CompetitionSlide() {
  return <section className="slide" style={{
    backgroundColor: '#0d1520'
  }} data-id="element-161">
      <div className="flex flex-col w-full h-full min-h-0 relative overflow-hidden" data-id="element-162">
        {/* Top text strip */}
        <div className="flex-shrink-0 flex flex-col min-h-0 overflow-hidden" style={{
        padding: 'clamp(1.5rem, 3vw, 3rem) clamp(2rem, 6vw, 6rem)'
      }} data-id="element-163">
          {/* Blue italic label */}
          <p className="italic font-semibold animate-fade-slide" style={{
          color: '#4A90D9',
          fontSize: 'var(--body-size)',
          marginBottom: 'clamp(0.3rem, 0.6vw, 0.5rem)',
          animationDelay: '0.1s'
        }} data-id="element-164">
            The competitive moat.
          </p>

          {/* Heading */}
          <h1 className="font-black tracking-tight leading-[0.95] text-white animate-fade-slide" style={{
          fontSize: 'var(--title-size)',
          marginBottom: 'clamp(0.4rem, 0.8vw, 0.6rem)',
          animationDelay: '0.15s'
        }} data-id="element-165">
            Other players answer WHERE. Only we answer WHY.
          </h1>

          {/* Body text */}
          <p className="animate-fade-slide" style={{
          color: 'rgba(255,255,255,0.45)',
          fontSize: 'var(--body-size)',
          lineHeight: '1.5',
          maxWidth: 'clamp(400px, 60vw, 800px)',
          marginBottom: 'clamp(1.5rem, 3vw, 2.5rem)',
          animationDelay: '0.18s'
        }} data-id="element-166">
            Every AI company is racing to answer WHERE. We're the only ones who
            can answer WHY this is for you - because we own the full user
            journey and the data layer underneath
          </p>
        </div>

        {/* Comparison Table */}
        <div className="flex-1 flex flex-col items-center relative overflow-hidden min-h-0 w-full" style={{
        padding: '0 clamp(2rem, 6vw, 6rem) clamp(2.5rem, 4vw, 4rem)'
      }} data-id="element-167">
          <div className="w-full max-w-5xl flex flex-col animate-fade-slide" style={{
          animationDelay: '0.3s'
        }} data-id="element-168">
            {/* Headers */}
            <div className="flex w-full" style={{
            marginBottom: 'clamp(0.75rem, 1.5vw, 1.25rem)',
            paddingBottom: 'clamp(0.5rem, 1vw, 0.75rem)',
            borderBottom: '1px solid rgba(255,255,255,0.1)'
          }} data-id="element-169">
              <div className="w-[40%] pr-4" data-id="element-170">
                <span className="uppercase tracking-[0.15em] font-semibold" style={{
                color: 'rgba(255,255,255,0.3)',
                fontSize: 'clamp(0.65rem, 1vw, 0.85rem)'
              }} data-id="element-171">
                  WHERE
                </span>
              </div>
              <div className="w-[60%] pl-4" data-id="element-172">
                <span className="uppercase tracking-[0.15em] font-semibold" style={{
                color: '#4A90D9',
                fontSize: 'clamp(0.65rem, 1vw, 0.85rem)'
              }} data-id="element-173">
                  WHY
                </span>
              </div>
            </div>

            {/* Rows */}
            <div className="flex flex-col" data-id="element-174">
              {/* Row 1 */}
              <div className="flex w-full items-center" style={{
              padding: 'clamp(0.75rem, 1.5vw, 1.25rem)',
              borderBottom: '1px solid rgba(255,255,255,0.06)'
            }} data-id="element-175">
                <div className="w-[40%] pr-4" data-id="element-176">
                  <span className="italic" style={{
                  color: 'rgba(255,255,255,0.35)',
                  fontSize: 'clamp(0.85rem, 1.5vw, 1.1rem)'
                }} data-id="element-177">
                    "Best tacos near me"
                  </span>
                </div>
                <div className="w-[60%] pl-4 flex flex-wrap items-center gap-2" data-id="element-178">
                  <span className="font-medium text-white/90" style={{
                  fontSize: 'clamp(0.9rem, 1.6vw, 1.2rem)'
                }} data-id="element-179">
                    "Walk me there on a safe, lit route"
                  </span>
                  <span className="rounded-full bg-teal-500/20 text-teal-400 border border-teal-500/30 whitespace-nowrap" style={{
                  fontSize: 'clamp(0.55rem, 0.9vw, 0.75rem)',
                  padding: 'clamp(2px, 0.3vw, 4px) clamp(8px, 1vw, 12px)'
                }} data-id="element-180">
                    safety
                  </span>
                </div>
              </div>

              {/* Row 2 */}
              <div className="flex w-full items-center" style={{
              padding: 'clamp(0.75rem, 1.5vw, 1.25rem)',
              borderBottom: '1px solid rgba(255,255,255,0.06)'
            }} data-id="element-181">
                <div className="w-[40%] pr-4" data-id="element-182">
                  <span className="italic" style={{
                  color: 'rgba(255,255,255,0.35)',
                  fontSize: 'clamp(0.85rem, 1.5vw, 1.1rem)'
                }} data-id="element-183">
                    "Top restaurants in SF"
                  </span>
                </div>
                <div className="w-[60%] pl-4 flex flex-wrap items-center gap-2" data-id="element-184">
                  <span className="font-medium text-white/90" style={{
                  fontSize: 'clamp(0.9rem, 1.6vw, 1.2rem)'
                }} data-id="element-185">
                    "Which ones match MY taste — and in what order?"
                  </span>
                  <span className="rounded-full bg-violet-500/20 text-violet-400 border border-violet-500/30 whitespace-nowrap" style={{
                  fontSize: 'clamp(0.55rem, 0.9vw, 0.75rem)',
                  padding: 'clamp(2px, 0.3vw, 4px) clamp(8px, 1vw, 12px)'
                }} data-id="element-186">
                    vibe
                  </span>
                </div>
              </div>

              {/* Row 3 */}
              <div className="flex w-full items-center" style={{
              padding: 'clamp(0.75rem, 1.5vw, 1.25rem)',
              borderBottom: '1px solid rgba(255,255,255,0.06)'
            }} data-id="element-187">
                <div className="w-[40%] pr-4" data-id="element-188">
                  <span className="italic" style={{
                  color: 'rgba(255,255,255,0.35)',
                  fontSize: 'clamp(0.85rem, 1.5vw, 1.1rem)'
                }} data-id="element-189">
                    "Things to do in Phoenix"
                  </span>
                </div>
                <div className="w-[60%] pl-4 flex flex-wrap items-center gap-2" data-id="element-190">
                  <span className="font-medium text-white/90" style={{
                  fontSize: 'clamp(0.9rem, 1.6vw, 1.2rem)'
                }} data-id="element-191">
                    "Plan my Saturday - kids, 2hrs, 110°"
                  </span>
                  <span className="rounded-full bg-orange-500/20 text-orange-400 border border-orange-500/30 whitespace-nowrap" style={{
                  fontSize: 'clamp(0.55rem, 0.9vw, 0.75rem)',
                  padding: 'clamp(2px, 0.3vw, 4px) clamp(8px, 1vw, 12px)'
                }} data-id="element-192">
                    planning
                  </span>
                </div>
              </div>

              {/* Row 4 */}
              <div className="flex w-full items-center" style={{
              padding: 'clamp(0.75rem, 1.5vw, 1.25rem)'
            }} data-id="element-193">
                <div className="w-[40%] pr-4" data-id="element-194">
                  <span className="italic" style={{
                  color: 'rgba(255,255,255,0.35)',
                  fontSize: 'clamp(0.85rem, 1.5vw, 1.1rem)'
                }} data-id="element-195">
                    "Hotels in Tokyo"
                  </span>
                </div>
                <div className="w-[60%] pl-4 flex flex-wrap items-center gap-2" data-id="element-196">
                  <span className="font-medium text-white/90" style={{
                  fontSize: 'clamp(0.9rem, 1.6vw, 1.2rem)'
                }} data-id="element-197">
                    "Which area has my energy AND walkable dinner?"
                  </span>
                  <span className="rounded-full bg-emerald-500/20 text-emerald-400 border border-emerald-500/30 whitespace-nowrap" style={{
                  fontSize: 'clamp(0.55rem, 0.9vw, 0.75rem)',
                  padding: 'clamp(2px, 0.3vw, 4px) clamp(8px, 1vw, 12px)'
                }} data-id="element-198">
                    walkability
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}